export default "__VITE_ASSET__DpRXTPDI__"